import { useState } from "react";
import { dispatch } from "../../state/store";
import { pushCreatedTableRowsIds, setDevicesRefresh } from "../../state/ducks";

import { strCode } from "../../consts";
import { fleetManagementService, notificationService, t } from "../../services";
import { csvUtil, fleetManagementUtil, responseUtil } from "../../utils";

export const useCreateDeviceBatch = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const mutationCallback = async (devicesFile, devices) => {
    setLoading(true);
    setError(false);

    try {
      const devicesFileText = await csvUtil.parseCsvAsText(devicesFile);

      const res = await fleetManagementService.createDeviceBatch(devicesFileText);

      if (responseUtil.isResponseSuccessful(res)) {
        const createdDusns = devices?.map((device) => device.dusn);

        dispatch(pushCreatedTableRowsIds(createdDusns));

        notificationService.showSuccess({
          title: t(strCode.CREATE_DEVICE_BATCH_SUCCESS),
          message: t(strCode.CREATE_DEVICE_BATCH_SUCCESS_INFO)
        });

        dispatch(setDevicesRefresh(true));
      }
    } catch (err) {
      setError(true);

      notificationService.showError({
        title: t(strCode.CREATE_DEVICE_BATCH_ERROR),
        message: t(
          fleetManagementUtil.parseDeviceErrorMessage(
            err?.response?.data?.error ? err?.response?.data?.error : err?.toString()
          )
        )
      });
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading, error };
};
